import React, { useState, useEffect } from 'react'
// import './FiResponse.css'
import PortalHeader from '../../../client-dashboard/clientNavbar/PortalHeader';
import { Link } from 'react-router-dom';

// Icons
import { RiSortAlphabetAsc, RiSortAlphabetDesc } from "react-icons/ri";
import { IoClose } from "react-icons/io5";

// Assets
import foreFlightBanner from '../../client-dashboard-assets/product-suit-assets/firesponse-banner.png'
import foreFlightGif from '../../client-dashboard-assets/product-suit-assets/firesponse-gif.gif'

const FiResponse = () => {

    // Ensure the page always start at the top
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top when the component mounts
    }, []);

    const [searchTerm, setSearchTerm] = useState('');
    const [sortAsc, setSortAsc] = useState(true);

    const emails = [
        "abel1@aviation.com",
        "flightops@airline.org",
        "safety.manager@flights.net",
        "pilot1@aviation.com",
        "bobflight@airline.org",
        "pilot1@aviation.com",
        "flightops@airline.org",
    ];

    const filteredEmails = emails.filter(email =>
        email.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedFilteredEmails = [...filteredEmails].sort((a, b) =>
        sortAsc ? a.localeCompare(b) : b.localeCompare(a)
    );


    return (
        <div className="overall-div-for-suite">

            <PortalHeader />

            <div className="suite-hero-section">
                <img src={foreFlightBanner} alt='foreflight-banner'></img>
                <div className="dark-overlay"></div>

                <div className="suite-wrapper">
                    <h1>fiReponse</h1>
                </div>
            </div>

            <div className='suite-default-info'>

                <div className='suite-info1'>
                    <h1><strong>Visualize High-Risk-Lightning™ in Your Wildfire Response Workflow</strong></h1>
                    <div className='suite-info1-inner'>
                        <p>FNN™’s High-Risk-Lightning™ (HRL™) data can be imported into fiResponse to help crews visualize potential ignition points and enhance response coordination.</p>

                        <img className='the-product-gif' src={foreFlightGif} alt='foreflight-gif'></img>
                    </div>
                </div>

                <div className='suite-info1'>
                    <h2><strong>Organization</strong></h2>
                    <p style={{ color: '#28aae1' }}>FNN</p>
                </div>

                <div className='suite-info1'>
                    <h2><strong>Data Delivery</strong></h2>

                    <p style={{ color: '#28aae1' }}>Daily</p>
                    <p style={{ color: '#28aae1' }}>Weekly</p>
                    <p>Your High-Risk Lightning™ data is delivered automatically on a daily and weekly basis.</p>

                </div>

                <div className='suite-info1'>
                    <h2><strong>Area Coverage</strong></h2>
                    <p style={{ color: '#28aae1' }}>State of Florida</p>
                </div>

                <div className='suite-info1'>
                    <h2><strong>Available Data </strong></h2>

                    <div className='suite-info1-inner'>
                        <p style={{ color: '#28aae1' }}>Date</p>
                        <p style={{ marginBottom: '0.5rem' }}>Timestamp of the detected strike</p>

                        <p style={{ color: '#28aae1' }}>Coordinates</p>
                        <p style={{ marginBottom: '0.5rem' }}>Latitude and longitude of the strike</p>

                        <p style={{ color: '#28aae1' }}>Precipitation</p>
                        <p style={{ marginBottom: '0.5rem' }}>Total rainfall recorded at the strike location.</p>
                    </div>
                </div>

                <div className='suite-info1'>
                    <h2><strong>Email Recipients</strong></h2>
                    <p>The following recipients are currently set to receive HRL™ data:</p>

                    <div className="esri-search-container" style={{ maxWidth: '30rem', position: 'relative' }}>
                        <input
                            className="esri-search-input"
                            type="text"
                            placeholder="Search Email Address"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            id='esri-name-search'
                            style={{ fontSize: '1rem' }}
                        />

                        <IoClose
                            className="clear-icon"
                            style={{
                                position: 'absolute',
                                right: '0.75rem',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer'
                            }}
                            onClick={() => setSearchTerm('')}
                        />

                    </div>

                    <div className="email-table-container">
                        <table className="suite-info1-table">
                            <thead>
                                <tr>
                                    <th>
                                        <div
                                            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', cursor: 'pointer' }}
                                            onClick={() => setSortAsc(prev => !prev)}
                                        >
                                            {/* <span>Email</span> */}
                                            {sortAsc ? <RiSortAlphabetAsc /> : <RiSortAlphabetDesc />}
                                        </div>
                                    </th>
                                </tr>
                            </thead>

                        </table>
                        <div className="email-table-scroll">
                            <table className="suite-info1-table">
                                <tbody>
                                    {sortedFilteredEmails.length > 0 ? (
                                        sortedFilteredEmails.map((email, idx) => (
                                            <tr key={idx}>
                                                <td> <span style={{ color: '#28aae1', fontWeight: '600' }}>{idx + 1}.</span> {email}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td>No matching emails found</td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>
                    </div>



                </div>

            </div>

            <div className='suite-info1'>
                <h2><strong> Questions about fiResponse Data & Import</strong></h2>
                <p>Have technical questions about importing data into fiResponse?</p>
                <p>HRL™ data not showing up on fiResponse dashboard?</p>
                            <Link to='/fnn_portal_representative'><button>Contact Us</button></Link>

            </div>

        
    </div>

 
  )
}

export default FiResponse